import { useRef, useState } from 'react';

/**
 * Закрытие боковой формы щелчком по затемнению вокруг неё — только настоящим щелчком: и нажатие, и отпускание на
 * самом затемнении (просьба владельца 28.10). Браузер шлёт click общему предку точек нажатия и отпускания: нажали в
 * поле формы (выделяли текст), отпустили за её краем — click доставался затемнению, и форма закрывалась.
 *
 * Нажатие и отпускание ловятся на перехвате: элементы формы, гасящие всплытие mousedown, не прячут их от затемнения.
 */
export const createBackdropClose = (getOnClose) => {
  let pressedOnBackdrop = false;
  let releasedOnBackdrop = false;
  return {
    onMouseDownCapture: (event) => { pressedOnBackdrop = event.target === event.currentTarget; },
    onMouseUpCapture: (event) => { releasedOnBackdrop = event.target === event.currentTarget; },
    onClick: (event) => {
      const close = pressedOnBackdrop && releasedOnBackdrop && event.target === event.currentTarget;
      pressedOnBackdrop = false;
      releasedOnBackdrop = false;
      const onClose = close ? getOnClose() : null;
      if (onClose) onClose();
    },
  };
};

/** Обработчики для `<div className="…-overlay" {...backdrop}>`; зовётся `onClose` последнего рендера. */
export const useBackdropClose = (onClose) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const [handlers] = useState(() => createBackdropClose(() => onCloseRef.current));
  return handlers;
};
